export const codes = {
  Thailand: '+66',
  Singapore: '+65',
};

export const countries = [
  {
    label: 'Singapore',
    value: 'Singapore',
  },
];

export const roles = [
  {
    label: 'Staff',
    value: 'staff',
  },
  {
    label: 'Customer',
    value: 'customer',
  },
];
